import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@monksflow/monks-ui';
import type { LucideIcon } from 'lucide-react';

interface Props {
  label: string;
  Icon: LucideIcon;
  disabled: boolean;
  onClick: () => void;
}

export function ZoomButton({ label, Icon, disabled, onClick }: Props) {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="mini"
          className="size-6 text-foreground disabled:opacity-40"
          aria-label={label}
          disabled={disabled}
          onClick={onClick}
        >
          <Icon className="size-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  );
}
